<div class="hero-bg hero-bg-contact">
  <app-navbar/>
  <div class="d-flex flex-column justify-content-center hero-header">
    <div class="app-container">
      <h1>{{ 'apply-job.description' | translate }}</h1>
    </div>
  </div>
</div>

<div class="app-container pt-4">
  <h2>{{ 'apply-job.content-title' | translate }}</h2>
  <div class="row mt-5">
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-6">
          <label>{{ 'lastName'| translate }}:</label>
          <div class="form-group">
            <input class="form-control" [(ngModel)]="model.lastName"
                   [disabled]="saving"
                   autocomplete="LastName"
                   [placeholder]="'lastName'| translate"/>
          </div>
        </div>
        <div class="col-md-6">
          <label>{{ 'firstName'| translate }}:</label>
          <div class="form-group">
            <input class="form-control" [(ngModel)]="model.firstName"
                   [disabled]="saving"
                   autocomplete="FirstName"
                   [placeholder]="'firstName'| translate"/>
          </div>
        </div>
      </div>
      <label>{{ 'phoneNumber'| translate }}:</label>
      <div class="form-group">
        <input class="form-control" [(ngModel)]="model.phoneNumber"
               [disabled]="saving"
               type="text"
               autocomplete="phoneNumber"
               [placeholder]="'phoneNumber'| translate"/>
      </div>

      <label>{{ 'email'| translate }}:</label>
      <div class="form-group">
        <input class="form-control" [(ngModel)]="model.email"
               [disabled]="saving"
               type="email"
               autocomplete="email"
               [placeholder]="'email'| translate"/>
      </div>

      <label>{{ 'desiredRole'| translate }}:</label>
      <div class="form-group">
        <input class="form-control" [(ngModel)]="model.desiredRole"
               [disabled]="saving"
               type="text"
               [placeholder]="'desiredRole'| translate"/>
      </div>

      <label>{{ 'experienceYears'| translate }}:</label>
      <div class="form-group">
        <input class="form-control" [(ngModel)]="model.experienceYears"
               [disabled]="saving"
               type="number"
               [placeholder]="'experienceYears'| translate"/>
      </div>


      <label>{{ 'cvUpload'| translate }}:</label>
      <div class="form-group">
        <file-input (onChange)="onFileChange($event)"/>
      </div>

      <label>{{ 'linkedinProfile'| translate }}:</label>
      <div class="form-group">
        <input class="form-control" [(ngModel)]="model.linkedin"
               [disabled]="saving"
               type="text"
               [placeholder]="'linkedinProfile'| translate"/>
      </div>

      <label>{{ 'event'| translate }}:</label>
      <div class="form-group">
        <input class="form-control" [(ngModel)]="model.event"
               [disabled]="saving"
               type="text"
               [placeholder]="'event'| translate"/>
      </div>

      <div class="alert alert-success" *ngIf="submitted">
        {{ success }}
      </div>
      <div class="alert alert-success" *ngIf="error">
        {{ error }}
      </div>
      <div class="col mt-2">
        <div class="form-check">
          <input type="checkbox" class="form-check-input"
                 [(ngModel)]="model.consent">
          <label class="form-check-label">
            {{ 'consent.name' |translate }}
            <a href="{{'consent.fileUrl'| translate}}" target="_blank">
              {{ 'consent.fileName' |translate }}
            </a>
          </label>
        </div>
      </div>
      <button (click)="submit()" *ngIf="!submitted" [disabled]="saving || !isValid()"
              type="submit"
              class="call-to-action-link-btn news-button me-2 mt-2">
        <span>{{ 'submitForm' |translate }}</span>
      </button>
    </div>
  </div>

</div>
